import { GA_EVENT, type GaEventNameType } from '@constants';
import { sendGTMEvent } from '@next/third-parties/google';

export class Analytics {
  private static instance: Analytics | null = null;
  private pageTimeRecord = new Map<string, number>();

  static getInstance() {
    if (Analytics.instance === null) {
      Analytics.instance = new Analytics();
      return Analytics.instance;
    }
    return Analytics.instance;
  }

  track<T extends GaEventNameType>(
    eventName: T,
    ...payloadParams: Parameters<(typeof GA_EVENT)[T]>
  ) {
    // @ts-expect-error: GA_EVENT[eventName]는 함수이므로 spread 연산자로 전달된 파라미터 배열을 적용
    const payload = GA_EVENT[eventName](...payloadParams);

    sendGTMEvent({
      ...payload,
    });
  }

  startPageTacking(pageName: string) {
    const pageId = `${pageName}-${Date.now()}`;
    this.pageTimeRecord.set(pageId, Date.now());
    return pageId;
  }

  tackPageLeave<T extends Extract<GaEventNameType, 'SIGNUP_SUCCESS'>>(
    eventName: T,
    pageId: string,
  ) {
    const stayTime = this.getStayTime(pageId);
    const payload = GA_EVENT[eventName]();

    sendGTMEvent({
      ...payload,
      event: 'ga-leave',
      stay_time: stayTime,
    });
  }

  private getStayTime(pageId: string) {
    const startTime = this.pageTimeRecord.get(pageId);
    if (!startTime) {
      return 0;
    }
    const stayTime = (Date.now() - startTime) / 1000;
    this.pageTimeRecord.delete(pageId);

    return stayTime;
  }
}
